"use client";

import { Geist, Geist_Mono } from "next/font/google";
import Link from "next/link";
import { useEffect } from "react";
import {
  primaryCtaClassName,
  secondaryCtaClassName,
  StatusPage,
} from "./_components/home/status-page";
import "./globals.css";

const geistSans = Geist({
  variable: "--font-geist-sans",
  subsets: ["latin"],
});

const geistMono = Geist_Mono({
  variable: "--font-geist-mono",
  subsets: ["latin"],
});

export default function GlobalError({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html
      lang="en"
      className={`${geistSans.variable} ${geistMono.variable} h-full antialiased`}
    >
      <body className="flex min-h-dvh flex-col">
        <title>Something went wrong — Convert MD to PDF</title>
        <StatusPage
          title="Something went wrong"
          description="Convert MD to PDF could not load this page. Try again, or return home and continue from there."
          detail={
            error.digest ? (
              <p className="mt-3 font-mono text-xs text-zinc-500">
                Error ID: {error.digest}
              </p>
            ) : null
          }
          actions={
            <>
              <button
                type="button"
                onClick={() => unstable_retry()}
                className={primaryCtaClassName}
              >
                Try again
              </button>
              <Link href="/" className={secondaryCtaClassName}>
                Go home
              </Link>
            </>
          }
        />
      </body>
    </html>
  );
}
